import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.0001 13.4C8.69748 13.4 10.3253 12.7257 11.5256 11.5255C12.7258 10.3252 13.4001 8.69736 13.4001 6.99998C13.4001 5.30259 12.7258 3.67472 11.5256 2.47449C10.3253 1.27426 8.69748 0.599976 7.0001 0.599976C5.30271 0.599976 3.67485 1.27426 2.47461 2.47449C1.27438 3.67472 0.600098 5.30259 0.600098 6.99998C0.600098 8.69736 1.27438 10.3252 2.47461 11.5255C3.67485 12.7257 5.30271 13.4 7.0001 13.4ZM9.9657 5.96558C10.1114 5.81469 10.1921 5.61261 10.1902 5.40285C10.1884 5.1931 10.1043 4.99245 9.95595 4.84412C9.80763 4.69579 9.60698 4.61166 9.39722 4.60984C9.18746 4.60801 8.98538 4.68865 8.8345 4.83438L6.2001 7.46878L5.1657 6.43438C5.01482 6.28865 4.81273 6.20801 4.60298 6.20984C4.39322 6.21166 4.19257 6.29579 4.04424 6.44412C3.89592 6.59245 3.81178 6.7931 3.80996 7.00285C3.80814 7.21261 3.88877 7.41469 4.0345 7.56558L5.6345 9.16558C5.78452 9.31555 5.98797 9.3998 6.2001 9.3998C6.41223 9.3998 6.61567 9.31555 6.7657 9.16558L9.9657 5.96558Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}